import { genericPage, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /permatitle-video/video/id/
const path = ['web', process.env.FOLDER_LAYOUTS, 'video'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { id } = context.query;
    const path = ['web', process.env.FOLDER_LAYOUTS, 'video'];
    if (!Number.isInteger(parseInt(id))) {
        return {
            notFound: true
        };
    }

    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
